export const REQUEST_SPECIFIC_METRIC = "request_specific_metric"
export const SPECIFIC_METRIC_SUCCESS = "specific_metric_success"
export const SPECIFIC_METRIC_FAILURE = "specific_metric_failure"
export const CLEAR_SPECIFIC_METRIC_STATE = "clear_specific_metric_state"